<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'gestoesDeAulas',
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Plano Semestral
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="gestaoDeAula">
        <v-card color="green lighten-1" outlined>
          <v-col cols="10">
            <v-card-text>
              <h4>Turma: {{ gestaoDeAula.turma?.descricao }}</h4>
              <h4>
                Disciplina:
                {{
                  gestaoDeAula.is_polivalencia === 1
                    ? gestaoDeAula.disciplina
                    : gestaoDeAula.disciplina.descricao
                }}
              </h4>
              <h4>
                Professor:
                {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
              </h4>
            </v-card-text>
          </v-col>
          <v-col cols="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="podeVerPlano"
                  x-small
                  class="ml-1 white--text"
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  @click="() => verHistoricoPlanos()"
                >
                  <span>Histórico do lancamento de planos</span>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-card>
      </v-col>
      <v-col cols="12 text-center" class="pt-2">
        <template>
          <v-toolbar>
            <v-tabs dark v-model="form.semestre" background-color="primary" grow>
              <v-tab
                v-for="item of $constants.semestres"
                :key="item.value"
                @click="() => atualizarPathAtual(item.value)"
              >
                <v-badge v-if="form.semestre === item.value" color="success">
                  {{ item.desc }}
                </v-badge>
                <div v-else>{{ item.desc }}</div>
              </v-tab>
            </v-tabs>
          </v-toolbar>
        </template>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }" v-if="!loadingPlano">
      <form @submit.prevent="handleSubmit(salvarPlanos)" :disabled="submittingForm">
        <v-row>
          <v-col cols="12">
            <ValidationProvider name="Tematica" rules="required" v-slot="{ errors }">
              <e-label>UNIDADES TEMÁTICAS / PRÁTICAS DE LINGUAGEM</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[semestreAtual].tematica"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Metodologia" rules="required" v-slot="{ errors }">
              <e-label>OBJETOS DO CONHECIMENTO</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[semestreAtual].objeto_conhecimento"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Habilidades" rules="required" v-slot="{ errors }">
              <e-label>HABILIDADES</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[semestreAtual].habilidades"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Metodologia" rules="required" v-slot="{ errors }">
              <e-label>METODOLOGIA</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[semestreAtual].metodologia"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Recursos didaticos" rules="required" v-slot="{ errors }">
              <e-label>RECURSOS DIDÁTICOS</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[semestreAtual].recursos_didaticos"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider
              name="Avaliação da aprendizagem"
              rules="required"
              v-slot="{ errors }"
            >
              <e-label>AVALIAÇÃO DA APRENDIZAGEM</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[semestreAtual].avaliacao_aprendizagem"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
          <v-col cols="12">
            <ValidationProvider name="Referencia" rules="required" v-slot="{ errors }">
              <e-label>REFERÊNCIAS</e-label>
              <v-textarea
                solo
                dense
                v-model="formData[semestreAtual].referencias"
                :error-messages="errors"
              />
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-col cols="12">
          <v-row>
            <v-btn
              block
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              >Enviar Dados</v-btn
            >
          </v-row>
        </v-col>
      </form>
    </ValidationObserver>
    <v-row v-else>
      <v-col cols="12">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
          <v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader>
          <v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader
          ><v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader
          ><v-skeleton-loader
            class="mx-auto"
            max-width="100%"
            height="100"
            type="paragraph"
          ></v-skeleton-loader>
        </v-sheet>
      </v-col>
    </v-row>
    <e-drawer-planos-lancados
      v-model="openDrawer"
      :gestao_id="parseInt($route.params.gestaoDeAulaId, 10)"
      :bimestre="parseInt(form.semestre, 10)"
      :disciplina_id="disciplina_id"
      @reloadPage="reloadPageData"
    />
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  async mounted() {
    this.loadingPlano = true;
    await this.loadData().then(() => {
      this.loadingPlano = false;
    });
  },
  data() {
    return {
      submittingForm: false,
      form: {
        semestre: 0,
      },
      openDrawer: false,
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
        disciplinas: [],
      },
      loadingPlano: true,
      plano_semestral: [],
      path: null,
      pathsList: [],
      pathAtual: [],
      formData: [],
      selectedTab: 0,
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    podeVerPlano() {
      return this.$constants.rolesParaGestores.find(
        (rpg) =>
          rpg.name ===
          this.user.roles.filter((role) => role.name === "super-admin").find((r) => true)?.name
      );
    },
    semestreAtual() {
      return this.form.semestre;
    },
    disciplina_id() {
      return parseInt(this.$route.params.disciplinaId, 10);
    },
    gestao_de_aula_id() {
      return parseInt(this.$route.params.gestaoDeAulaId, 10);
    },
  },
  methods: {
    async salvarPlanos() {
      this.$loaderService.open("Carregando dados...");
      try {
        this.formData = this.formData.map((item) => {
          return {
            ...item,
            instrutorDisciplinaTurma_id: this.gestao_de_aula_id,
            disciplina_id: this.disciplina_id,
          };
        });

        await this.$services.planosSemestraisService.salvarPlanos(
          this.formData,
          this.gestao_de_aula_id,
          this.disciplina_id
        );

        await this.loadData();
        this.$toast.success("Planos salvos com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    atualizarPathAtual(semestre) {
      this.pathAtual = this.formData[semestre].path;
    },
    async onFileSelected(file) {
      if (file) {
        const { gestaoDeAulaId, disciplinaId } = this.$route.params;

        try {
          const response = await this.$services.planosSemestraisService.planoSemestralPDF(
            gestaoDeAulaId,
            this.semestreAtual,
            disciplinaId,
            file
          );

          // console.log("Arquivo enviado com sucesso:", response);
          this.pathAtual = response.path;
          this.formData[semestre].path = response.path;
        } catch (error) {
          // console.error("Erro ao enviar o arquivo:", error);
        } finally {
          this.isUploading = false;
        }
      }
    },
    async downloadPlanoSemestral() {
      const { gestaoDeAulaId, disciplinaId } = this.$route.params;
      try {
        await this.$services.planosSemestraisService.planoSemestralDownload(
          gestaoDeAulaId,
          this.semestreAtual,
          disciplinaId
        );
      } catch (error) {
        // console.error("Erro ao baixar o arquivo:", error);
      }
    },
    async verHistoricoPlanos() {
      this.openDrawer = !this.openDrawer;
    },
    async createOrUpdate() {
      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        const { semestre } = this.form;
        this.form.semestre = semestre;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.disciplina_id = this.disciplina_id;
        await this.$services.planosSemestraisService.createOrUpdate(this.form);
        this.$toast.success("Plano semestral salvo com sucesso!");
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async loadData() {
      const { gestaoDeAulaId, disciplinaId } = this.$route.params;

      try {
        this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizar(gestaoDeAulaId);

        const response = await this.$services.planosSemestraisService.pegarPlanos(
          gestaoDeAulaId,
          disciplinaId
        );

        const semestresExistentes = [];
        response.planos.map((plano, index) => {
          this.formData[plano.semestre] = { ...plano };
          semestresExistentes.push(plano.semestre);
        });

        const semestresInexistenes = this.$constants.semestres
          .filter((semestre) => {
            return !semestresExistentes.includes(semestre.value);
          })
          .map((b) => b.value);

        semestresInexistenes.map((semestre) => {
          this.formData[semestre] = {
            instrutorDisciplinaTurma_id: gestaoDeAulaId,
            disciplina_id: disciplinaId,
            semestre,
          };
        });

        if (response.planos.length > 0) {
          this.pathsList = response.planos.map((i) => i.path);
          this.pathAtual = this.pathsList[this.semestreAtual];
        }

        if (this.gestaoDeAula.disciplinas.length > 0) {
          const disciplina = this.gestaoDeAula.disciplinas.filter((i) => {
            return i.id === this.disciplina_id;
          });
          this.gestaoDeAula.disciplina = disciplina[0].descricao;
        }

        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
    },
    async reloadPageData() {
      await this.loadData();
    },
  },
};
</script>

<style></style>
